import { Injectable } from '@angular/core';
import { filter, Subject } from 'rxjs'
import { Observable } from 'rxjs/internal/Observable'
import { IPluginEvent, PluginID } from './plugin-event.interface';

@Injectable({
  providedIn: 'root'
})
export class PluginEventService {
  // event bus on which events are sent and received
  private eventSubject = new Subject<IPluginEvent>();

  // publish an event
  publish(event: IPluginEvent): void {
    this.eventSubject.next(event);
  }

  // listen to events intended for a specific event destination
  listenToEventsFor(destination: PluginID): Observable<IPluginEvent> {
    return this.eventSubject.asObservable().pipe(
      // only return events for the matching plugin ID
      filter((event: IPluginEvent) => event.to === destination)
    );
  }
}
